module.exports = __webpack_public_path__ + "img/cap.c8d061eb.jpg";